import React, {useContext} from "react";
import Column from "@meridian/components/column";
import helpTokens from "@meridian/tokens/base/icon/help";
import {TopNavigationView, HelpView} from "dolphin-meridian-react-components";
import {AppNavigationContext} from "./context/AppNavigationContext";
import help_icon from "../../images/ic_help_coming_up.png"

export default function AppTopNavigation() {

    const {navState, navActions} = useContext(AppNavigationContext);

    return (
        <Column>
            <TopNavigationView
                title={navState.title}
                backgroundColor={navState.navColor}
                onMenuButtonClicked={navState.onBackClicked}
                optionsMenu={navState.helpEnabled ? [{
                    icon: helpTokens, onClick: navActions.openHelp
                }] : []}/>
            {navState.helpOptions.open && <HelpView
                onClose={navActions.closeHelp}
                title={navState.helpOptions.title}
                pageTitle={navState.helpOptions.pageTitle}
                list={navState.helpOptions.list}
                help_icon={help_icon}/>}
        </Column>
    );
}



// WEBPACK FOOTER //
// ./src/components/appNavigation/AppNavigation.js